import GenericDB from './generic-db';

export default class DeviceLayout extends GenericDB {
  constructor(deviceId) {
    super(`devices/${deviceId}/layout`);
  }

  // Here you can extend UserDB with custom methods
}
